import React, { useRef } from 'react';
import './DestinationInput.css';

interface DestinationInputProps {
  onAdd: (destination: string) => void;
  placeholder?: string;
  className?: string;
}

const DestinationInput: React.FC<DestinationInputProps> = ({ 
  onAdd, 
  placeholder = 'Add destination...',
  className = '' 
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleAdd = () => {
    if (inputRef.current) {
      const value = inputRef.current.value.trim();
      if (value) {
        onAdd(value);
        inputRef.current.value = '';
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    
    // Remove all characters except Unicode letters, spaces, and one comma
    // First, keep only the first comma and remove any additional commas
    const commaIndex = value.indexOf(',');
    if (commaIndex !== -1) {
      // Keep everything before the first comma, the comma itself, and filter the rest
      const beforeComma = value.substring(0, commaIndex + 1);
      const afterComma = value.substring(commaIndex + 1).replace(/,/g, ''); // Remove additional commas
      value = beforeComma + afterComma;
    }
    
    // Allow Unicode letters (using character class that works across languages), spaces, and comma
    // This regex matches letters from most languages including Latin, Cyrillic, Greek, Arabic, Chinese, Japanese, etc.
    const filteredValue = value.replace(/[^\p{L}\s,]/gu, '');
    
    // Trim spaces after filtering
    const trimmedValue = filteredValue.trim();
    e.target.value = trimmedValue;
  };

  return (
    <div className={`destination-input-container ${className}`}>
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        className="destination-input"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      <button
        onClick={handleAdd}
        className="destination-input-button"
        type="button"
      >
        Add
      </button>
    </div>
  );
};

export default DestinationInput;

